namespace $.$$ {

	export class $shm_dashboard_admin_user_dashboards extends $.$shm_dashboard_admin_user_dashboards {

		admin_authenticated() {
			return this.$.$shm_pb.admin_authenticated()
		}

		admin_token_present() {
			return Boolean( this.$.$shm_pb.admin_auth_token() )
		}

		filter_text( value: string ) {
			return String( value ).replaceAll( '\\', '\\\\' ).replaceAll( '"', '\\"' )
		}

		users() {
			if( !this.admin_token_present() ) return [] as readonly $shm_pocketbase_record[]
			return this.$.$shm_pb.admin_records_all_realtime( 'users\n\nemail' )
		}

		user_options() {
			const options = {} as Record< string, string >

			for( const user of this.users() ) {
				options[ user.id ] = String(
					user.email
					?? user.name
					?? user.username
					?? user.id
				)
			}

			return options
		}

		selected_user_id( next?: string ) {
			if( next !== undefined ) return super.selected_user_id( next )
			return super.selected_user_id() || this.user_id().trim() || this.users()[0]?.id || ''
		}

		active_user_id() {
			const selected = this.selected_user_id()
			return this.users().some( user => user.id === selected ) ? selected : ''
		}

		active_user() {
			const id = this.active_user_id()
			return id ? this.users().find( user => user.id === id ) ?? null : null
		}

		active_user_data() {
			return this.active_user()
		}

		active_user_title() {
			const user = this.active_user()
			return String(
				user?.name
					|| user?.email
					|| user?.username
					|| user?.id
					|| 'Пользователь'
			)
		}

		page_title() {
			return this.active_user_title()
		}

		@ $mol_mem
		section_mode( next?: string ) {
			return next ?? 'monitoring'
		}

		section_content() {
			switch( this.section_mode() ) {
				case 'mention_stats': return [ this.Mention_stats_content() ]
				case 'wordstat': return [ this.Wordstat_content() ]
				case 'agent': return [ this.Agent_content() ]
				case 'logs': return [ this.Logs_content() ]
				default: return [ this.Monitoring_content() ]
			}
		}

		dashboards() {
			if( !this.admin_token_present() ) return [] as readonly $shm_pocketbase_record[]
			const user = this.active_user_id()
			if( !user ) return [] as readonly $shm_pocketbase_record[]
			return this.$.$shm_pb.records_realtime( `user_dashboards\nuser.id ?= "${ this.filter_text( user ) }"\nsort,title` )
		}

		dashboard_create_enabled() {
			return Boolean( this.admin_token_present() && this.active_user_id() )
		}

		@ $mol_action
		dashboard_create( next?: Event ) {
			if( next === undefined ) return null

			if( !this.admin_authenticated() ) return next
			const user = this.active_user_id()
			if( !user ) return next

			this.$.$shm_pb.create_record( 'user_dashboards', {
				user: [ user ],
				title: `Дашборд ${ this.dashboards().length + 1 }`,
				sort: this.dashboard_sort_next(),
			} )

			return next
		}

		dashboard_sort_next() {
			return this.dashboards().reduce(
				( max, dashboard )=> Math.max( max, Number( dashboard.sort ?? 0 ) ),
				0,
			) + 10
		}

		body_rows() {
			const dashboards = this.dashboards()
			if( !this.active_user_id() ) return [ this.Empty() ]
			if( !dashboards.length ) return [ this.No_dashboards() ]
			return dashboards.map( dashboard => this.Dashboard( dashboard.id ) )
		}

		dashboard( id: string ) {
			return this.dashboards().find( dashboard => dashboard.id === id ) ?? null
		}

		dashboard_users( id: string ) {
			const value = this.dashboard( id )?.user
			if( Array.isArray( value ) ) return value.map( String ).filter( Boolean )
			return value ? [ String( value ) ] : []
		}

		dashboard_user_rows( id: string ) {
			return this.users().map( user => this.Dashboard_user( `${ id }\n${ user.id }` ) )
		}

		dashboard_access_title( id: string ) {
			const count = this.dashboard_users( id ).length
			return count ? `Доступ (${ count })` : 'Доступ'
		}

		dashboard_available_tags( id: string ) {
			return [ ... new Set(
				this.files( id ).flatMap( file => Array.isArray( file.tags ) ? file.tags.map( String ) : [] ),
			) ].map( tag => tag.trim() ).filter( Boolean ).sort( ( left, right )=> left.localeCompare( right, 'ru' ) )
		}

		dashboard_visible_tags( id: string ) {
			const dashboard = this.dashboard( id )
			if( Array.isArray( dashboard?.visible_tags ) ) return dashboard.visible_tags.map( String ).filter( Boolean )
			const excluded = new Set( Array.isArray( dashboard?.excluded_tags ) ? dashboard.excluded_tags.map( String ) : [] )
			return this.dashboard_available_tags( id ).filter( tag => !excluded.has( tag ) )
		}

		dashboard_tags_title( id: string ) {
			return `Теги (${ this.dashboard_visible_tags( id ).length })`
		}

		dashboard_tag_rows( id: string ) {
			return this.dashboard_available_tags( id ).map( tag => this.Dashboard_tag( `${ id }\n${ tag }` ) )
		}

		dashboard_tag_title( key: string ) {
			return key.split( '\n' ).slice( 1 ).join( '\n' )
		}

		dashboard_tag_checked( key: string, next?: boolean ) {
			const [ id, ...parts ] = key.split( '\n' )
			const tag = parts.join( '\n' )
			const visible = this.dashboard_visible_tags( id )
			if( next === undefined ) return visible.includes( tag )
			if( !this.admin_authenticated() ) return next
			const selected = next ? [ ... new Set([ ...visible, tag ]) ] : visible.filter( value => value !== tag )
			this.$.$shm_pb.update_record( 'user_dashboards', id, { visible_tags: selected, excluded_tags: [] } )
			return next
		}

		@ $mol_mem_key
		dashboard_tags_outside_listener( id: string ) {
			if( !this.dashboard_tags_showed( id ) ) return null
			return new this.$.$shm_listener(
				'pointerdown',
				event => this.dashboard_tags_outside( id, event ),
				this.$.$mol_dom_context.document,
				{ passive: true },
			)
		}

		dashboard_tags_outside( id: string, event?: PointerEvent ) {
			const target = event?.target
			if( !( target instanceof this.$.$mol_dom_context.Node ) ) return event ?? null
			if( this.Dashboard_tags( id ).dom_node().contains( target ) ) return event ?? null
			this.dashboard_tags_showed( id, false )
			return event ?? null
		}

		@ $mol_mem_key
		dashboard_access_outside_listener( id: string ) {
			if( !this.dashboard_access_showed( id ) ) return null
			return new this.$.$shm_listener(
				'pointerdown',
				event => this.dashboard_access_outside( id, event ),
				this.$.$mol_dom_context.document,
				{ passive: true },
			)
		}

		dashboard_access_outside( id: string, event?: PointerEvent ) {
			const target = event?.target
			if( !( target instanceof this.$.$mol_dom_context.Node ) ) return event ?? null
			if( this.Dashboard_access( id ).dom_node().contains( target ) ) return event ?? null
			this.dashboard_access_showed( id, false )
			return event ?? null
		}

		dashboard_user_title( dashboard_user: string ) {
			const user_id = dashboard_user.split( '\n' )[1] ?? ''
			const user = this.users().find( user => user.id === user_id )
			return String( user?.email ?? user?.name ?? user?.username ?? user_id )
		}

		dashboard_user_checked( dashboard_user: string, next?: boolean ) {
			const [ dashboard_id, user_id ] = dashboard_user.split( '\n' )
			const users = this.dashboard_users( dashboard_id )
			if( next === undefined ) return users.includes( user_id )
			if( !this.admin_authenticated() ) return next
			if( !user_id ) return next

			const next_users = next
				? [ ... new Set([ ... users, user_id ]) ]
				: users.filter( user => user !== user_id )
			if( !next_users.length ) return true

			this.$.$shm_pb.update_record( 'user_dashboards', dashboard_id, { user: next_users } )
			return next
		}

		dashboard_title( id: string ) {
			const dashboard = this.dashboard( id )
			return String( dashboard?.title ?? dashboard?.name ?? id )
		}

		@ $mol_mem_key
		dashboard_title_draft( id: string, next?: string ) {
			$mol_wire_solid()
			return next ?? this.dashboard_title( id )
		}

		@ $mol_action
		dashboard_title_commit( id: string, next?: Event ) {
			if( next === undefined ) return null

			if( !this.admin_token_present() ) return next
			const prev = this.dashboard_title( id )
			const title = this.dashboard_title_draft( id ).trim()

			if( !title ) {
				this.dashboard_title_draft( id, prev )
				return next
			}

			if( title !== prev ) this.$.$shm_pb.update_record( 'user_dashboards', id, { title } )
			this.dashboard_title_draft( id, title )

			return next
		}

		@ $mol_action
		dashboard_title_keydown( id: string, next?: KeyboardEvent ) {
			if( next?.key !== 'Escape' ) return next ?? null

			next.preventDefault()
			this.dashboard_title_draft( id, this.dashboard_title( id ) )
			this.Dashboard_title( id ).focused( false )

			return next
		}

		dashboard_rows( id: string ) {
			return [
				this.Dashboard_head( id ),
				this.upload_pending_files( id ).length ? this.Upload_tags( id ) : null,
				this.Files( id ),
				this.more_visible( id ) ? this.More( id ) : null,
			].filter( Boolean ) as readonly $mol_view[]
		}

		per_page() {
			return 50
		}

		log_per_page() {
			return 50
		}

		@ $mol_mem_key
		page( id: string, next?: number ) {
			return next ?? 1
		}

		@ $mol_mem
		log_page( next?: number ) {
			return next ?? 1
		}

		files( id: string ) {
			if( !this.admin_token_present() ) return [] as readonly $shm_pocketbase_record[]
			return this.$.$shm_pb.records_page_realtime(
				`dashboard_files\ndashboard = "${ this.filter_text( id ) }"\nsort,title\n1\n${ this.page( id ) * this.per_page() }`,
			)
		}

		file_rows( id: string ) {
			const files = this.files( id )
			if( !files.length ) return [ this.No_files( id ) ]
			return files.map( file => this.File( file.id ) )
		}

		file( id: string ) {
			for( const dashboard of this.dashboards() ) {
				const file = this.files( dashboard.id ).find( file => file.id === id )
				if( file ) return file
			}
			return null
		}

		file_title( id: string ) {
			const file = this.file( id )
			if( !file ) return id
			return String( file.title || id )
		}

		@ $mol_mem_key
		file_title_draft( id: string, next?: string ) {
			$mol_wire_solid()
			return next ?? this.file_title( id )
		}

		@ $mol_action
		file_title_commit( id: string, next?: Event ) {
			if( next === undefined ) return null
			const previous = this.file_title( id )
			const title = this.file_title_draft( id ).trim()
			if( !title ) {
				this.file_title_draft( id, previous )
				return next
			}
			if( title !== previous && this.admin_authenticated() ) this.$.$shm_pb.update_record( 'dashboard_files', id, { title } )
			this.file_title_draft( id, title )
			return next
		}

		@ $mol_action
		file_title_keydown( id: string, next?: KeyboardEvent ) {
			if( next?.key !== 'Escape' ) return next ?? null
			next.preventDefault()
			this.file_title_draft( id, this.file_title( id ) )
			this.File_title_text( id ).focused( false )
			return next
		}

		file_name( id: string ) {
			const file = this.file( id )
			if( !file ) return ''
			const files = this.$.$shm_pb.record_files( file, 'file' )
			return files.length ? `(${ files.join( ', ' ) })` : ''
		}

		more_visible( id: string ) {
			return this.files( id ).length >= this.page( id ) * this.per_page()
		}

		more( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.page( id, this.page( id ) + 1 )
			return next
		}

		logs(): readonly $shm_pocketbase_record[] {
			if( !this.admin_token_present() ) return [] as readonly $shm_pocketbase_record[]
			const user = this.active_user_id()
			if( !user ) return [] as readonly $shm_pocketbase_record[]

			const by_relation = this.log_records_try(
				`user_logs\nuser = "${ this.filter_text( user ) }"\n-created\n1\n${ this.log_page() * this.log_per_page() }`,
			)
			if( by_relation ) return by_relation

			const by_relation_id = this.log_records_try(
				`user_logs\nuser.id = "${ this.filter_text( user ) }"\n-created\n1\n${ this.log_page() * this.log_per_page() }`,
			)
			if( by_relation_id ) return by_relation_id

			return this.log_records_try(
				`user_logs\n\n\n1\n200`,
			)
				?.filter( log => String( log.user ?? '' ) === user )
				.sort( ( left, right )=> this.log_date_value( right ).localeCompare( this.log_date_value( left ) ) )
				.slice( 0, this.log_page() * this.log_per_page() )
				?? []
		}

		log_records_try( collection_filter_page: string ): readonly $shm_pocketbase_record[] | null {
			const result = $mol_error_fence(
				()=> this.$.$shm_pb.admin_records_page( collection_filter_page ),
				()=> null,
				promise => promise,
			)

			if( $mol_promise_like( result ) ) return null
			return result
		}

		log_rows() {
			const logs = this.logs()
			if( !this.active_user_id() ) return [ this.No_logs() ]
			if( !logs.length ) return [ this.No_logs() ]
			return [ this.Log_head(), ... logs.map( log => this.Log_row( log.id ) ) ]
		}

		log_content() {
			return [
				this.Log_list(),
				this.log_more_visible() ? this.Log_more() : null,
			].filter( Boolean ) as readonly $mol_view[]
		}

		log( id: string ) {
			return this.logs().find( log => log.id === id ) ?? null
		}

		log_date_value( log: $shm_pocketbase_record | null ) {
			return String( log?.created ?? log?.updated ?? '' )
		}

		log_created( id: string ) {
			const created = this.log_date_value( this.log( id ) )
			if( !created ) return ''

			const date = new Date( created )
			if( Number.isNaN( date.getTime() ) ) return created
			return date.toLocaleString( 'ru-RU' )
		}

		log_event( id: string ) {
			return String( this.log( id )?.event ?? '' )
		}

		log_url( id: string ) {
			return String( this.log( id )?.url ?? '' )
		}

		log_user_agent( id: string ) {
			return String( this.log( id )?.user_agent ?? '' )
		}

		log_more_visible() {
			return this.logs().length >= this.log_page() * this.log_per_page()
		}

		log_more( next?: Event ) {
			if( next === undefined ) return null
			this.log_page( this.log_page() + 1 )
			return next
		}

		@ $mol_action
		dashboard_delete( id: string, next?: Event ) {
			if( next === undefined ) return null

			this.dashboard_delete_showed( id, false )
			if( !this.admin_authenticated() ) return next

			for( const file of this.files( id ) ) {
				this.$.$shm_pb.delete_record( 'dashboard_files', file.id )
			}

			this.$.$shm_pb.delete_record( 'user_dashboards', id )

			return next
		}

		@ $mol_mem_key
		dashboard_delete_outside_listener( id: string ) {
			if( !this.dashboard_delete_showed( id ) ) return null
			return new this.$.$shm_listener(
				'pointerdown',
				event => this.dashboard_delete_outside( id, event ),
				this.$.$mol_dom_context.document,
				{ passive: true },
			)
		}

		dashboard_delete_outside( id: string, event?: PointerEvent ) {
			const target = event?.target
			if( !( target instanceof this.$.$mol_dom_context.Node ) ) return event ?? null
			if( this.Dashboard_delete( id ).dom_node().contains( target ) ) return event ?? null
			this.dashboard_delete_showed( id, false )
			return event ?? null
		}

		dashboard_delete_cancel( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.dashboard_delete_showed( id, false )
			return next
		}

		@ $mol_action
		file_delete( id: string, next?: Event ) {
			if( next === undefined ) return null

			this.file_delete_showed( id, false )
			if( !this.admin_authenticated() ) return next
			this.$.$shm_pb.delete_record( 'dashboard_files', id )

			return next
		}

		@ $mol_mem_key
		file_delete_outside_listener( id: string ) {
			if( !this.file_delete_showed( id ) ) return null
			return new this.$.$shm_listener(
				'pointerdown',
				event => this.file_delete_outside( id, event ),
				this.$.$mol_dom_context.document,
				{ passive: true },
			)
		}

		file_delete_outside( id: string, event?: PointerEvent ) {
			const target = event?.target
			if( !( target instanceof this.$.$mol_dom_context.Node ) ) return event ?? null
			if( this.File_delete( id ).dom_node().contains( target ) ) return event ?? null
			this.file_delete_showed( id, false )
			return event ?? null
		}

		file_delete_cancel( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.file_delete_showed( id, false )
			return next
		}

		@ $mol_mem_key
		upload_pending_files( id: string, next?: readonly File[] ) {
			return next ?? []
		}

		@ $mol_mem_key
		upload_file_tags( id: string, next?: ReadonlyMap< string, readonly string[] > ) {
			return next ?? new Map
		}

		@ $mol_mem_key
		upload_kind( id: string, next?: 'direct' | 'duckdb' ) {
			return next ?? 'direct'
		}

		parse_csv_line( line: string ) {
			const delimiter = ( line.match( /;/g )?.length || 0 ) >= ( line.match( /,/g )?.length || 0 ) ? ';' : ','
			const cells: string[] = []
			let value = ''
			let quoted = false
			for( let index = 0; index < line.length; ++ index ) {
				const char = line[ index ]
				if( char === '"' ) {
					if( quoted && line[ index + 1 ] === '"' ) value += line[ ++ index ]
					else quoted = !quoted
				} else if( char === delimiter && !quoted ) {
					cells.push( value.trim() )
					value = ''
				} else value += char
			}
			cells.push( value.trim() )
			return cells.filter( Boolean )
		}

		upload_files( id: string, next?: readonly File[] ) {
			if( next === undefined ) return [] as readonly File[]
			if( !this.admin_authenticated() ) return [] as readonly File[]
			$mol_wire_async( this ).upload_prepare( id, [ ...next ], 'direct' ).catch( error => {
				if( !$mol_promise_like( error ) ) console.error( error )
			} )
			return [] as readonly File[]
		}

		async upload_prepare( id: string, files: readonly File[], kind: 'direct' | 'duckdb' ) {
			const tags = new Map< string, readonly string[] >
			for( const file of files ) {
				const bytes = await file.arrayBuffer()
				let text = new TextDecoder( 'utf-8' ).decode( bytes )
				if( !text.includes( 'Дата' ) ) text = new TextDecoder( 'windows-1251' ).decode( bytes )
				const head = this.parse_csv_line( ( text.replace( /^\uFEFF/, '' ).split( /\r?\n/ )[4] ?? '' ) )
				const address = head.indexOf( 'Адрес' )
				const start = address === -1 ? head.indexOf( 'Telemetr' ) : address + 1
				tags.set( file.name, start === -1 ? [] : head.slice( start ).filter( tag => !tag.startsWith( '_' ) ) )
			}
			this.upload_file_tags( id, tags )
			this.upload_kind( id, kind )
			this.upload_pending_files( id, files )
		}

		upload_tag_names( id: string ) {
			return [ ... new Set([ ...this.upload_file_tags( id ).values() ].flat()) ].sort( ( left, right )=> left.localeCompare( right, 'ru' ) )
		}

		upload_tag_rows( id: string ) {
			return this.upload_tag_names( id ).map( tag => this.Upload_tag( `${ id }\n${ tag }` ) )
		}

		upload_tag_title( key: string ) {
			return key.split( '\n' ).slice( 1 ).join( '\n' )
		}

		@ $mol_mem_key
		upload_tag_checked( key: string, next?: boolean ) {
			return next ?? true
		}

		@ $mol_action
		upload_confirm( id: string, next?: Event ) {
			if( next === undefined ) return null
			const files = this.upload_pending_files( id )
			const selected = new Set( this.upload_tag_names( id ).filter( tag => this.upload_tag_checked( `${ id }\n${ tag }` ) ) )
			if( this.upload_kind( id ) === 'duckdb' ) {
				this.csv_to_duckdb_uploading( id, true )
				$mol_wire_async( this ).csv_to_duckdb_upload_all( id, files, [ ...selected ] ).catch( error => {
					if( !$mol_promise_like( error ) ) console.error( error )
				} ).finally( ()=> this.csv_to_duckdb_uploading( id, false ) )
			} else {
				for( const file of files ) {
					const form = new FormData()
					form.set( 'dashboard', id )
					form.set( 'title', file.name )
					form.set( 'tags', JSON.stringify( ( this.upload_file_tags( id ).get( file.name ) ?? [] ).filter( ( tag: string )=> selected.has( tag ) ) ) )
					form.set( 'file', file )
					this.$.$shm_pb.create_form_record( 'dashboard_files', form )
				}
			}
			const visible = [ ... new Set([ ...this.dashboard_visible_tags( id ), ...selected ]) ]
			this.$.$shm_pb.update_record( 'user_dashboards', id, { visible_tags: visible, excluded_tags: [] } )
			this.upload_pending_files( id, [] )
			this.upload_file_tags( id, new Map )
			return next
		}

		upload_cancel( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.upload_pending_files( id, [] )
			this.upload_file_tags( id, new Map )
			return next
		}

		csv_to_duckdb_url() {
			return 'https://duckdb.158-160-195-195.ip.hyoo.ru/dashboard_duckdb'
		}

		csv_to_duckdb_files( id: string, next?: readonly File[] ) {
			if( next === undefined ) return [] as readonly File[]
			if( !this.admin_authenticated() ) return [] as readonly File[]
			if( this.csv_to_duckdb_uploading( id ) ) return [] as readonly File[]

			$mol_wire_async( this ).upload_prepare( id, [ ...next ], 'duckdb' ).catch( error => {
				if( !$mol_promise_like( error ) ) console.error( error )
			} )

			return [] as readonly File[]
		}

		@ $mol_mem_key
		csv_to_duckdb_uploading( id: string, next?: boolean ) {
			return next ?? false
		}

		csv_to_duckdb_title( id: string ) {
			return this.csv_to_duckdb_uploading( id ) ? 'Загрузка...' : 'csv -> duckdb'
		}

		csv_to_duckdb_enabled( id: string ) {
			return !this.csv_to_duckdb_uploading( id )
		}

		async csv_to_duckdb_upload_all( id: string, files: readonly File[], visible_tags: readonly string[] ) {
			for( const file of files ) await this.csv_to_duckdb_upload( id, file, visible_tags )
		}

		wordstat_tasks() {
			const user = this.active_user_id()
			if( !user || !this.admin_token_present() ) return [] as readonly $shm_pocketbase_record[]
			return this.$.$shm_pb.records_page_realtime_live(
				`wordstat_tasks\nuser = "${ this.filter_text( user ) }"\n-sort\n1\n500\nid,user,title,sort,settings,collect_total,regular_daily`,
				`wordstat_tasks/admin:${ user }`,
				record => String( record.user || '' ) === user,
			)
		}

		wordstat_task_items() {
			const user = this.active_user_id()
			if( !user || !this.admin_token_present() ) return [] as readonly $shm_pocketbase_record[]
			return this.$.$shm_pb.records_page_realtime_live(
				`wordstat_task_items\ntask.user = "${ this.filter_text( user ) }" && result_stored = true\ndate_from\n1\n10000\nid,task,date_from,result_stored`,
				`wordstat_task_items/admin:${ user }`,
				record => Boolean( record.result_stored ),
			)
		}

		mention_stats_tasks() {
			const user = this.active_user_id()
			if( !user || !this.admin_token_present() ) return [] as readonly $shm_pocketbase_record[]
			return this.$.$shm_pb.records_page_realtime_live(
				`mention_stats_tasks\nuser = "${ this.filter_text( user ) }"\n-sort\n1\n500\nid,user,title,sort,settings,status,result_file,row_count`,
				`mention_stats_tasks/admin:${ user }`,
				record => String( record.user || '' ) === user,
			)
		}

		mention_stats_task( id: string ) {
			return this.mention_stats_tasks().find( task => task.id === id ) ?? null
		}

		mention_stats_task_rows() {
			const tasks = this.mention_stats_tasks()
			return tasks.length ? tasks.map( task => this.Mention_stats_task( task.id ) ) : [ this.Mention_stats_empty() ]
		}

		mention_stats_content_rows() {
			return [
				this.Mention_stats_user_settings(),
				this.Mention_stats_toolbar(),
				this.Mention_stats_list(),
				... this.selected_mention_stats_task_id() ? [ this.Mention_stats_dashboard() ] : [],
			]
		}

		mention_stats_task_title_next() {
			const used = new Set( this.mention_stats_tasks().map( task => String( task.title || '' ).trim() ) )
			for( let index = 1; ; ++ index ) if( !used.has( `Задача ${ index }` ) ) return `Задача ${ index }`
		}

		mention_stats_task_sort_next() {
			return this.mention_stats_tasks().reduce( ( max, task )=> Math.max( max, Number( task.sort || 0 ) ), 0 ) + 10
		}

		@ $mol_action
		mention_stats_create( next?: Event ) {
			if( next === undefined ) return null
			const user = this.active_user_id()
			if( !user || !this.admin_authenticated() ) return next
			const record = this.$.$shm_pb.create_record( 'mention_stats_tasks', {
				user,
				title: this.mention_stats_task_title_next(),
				sort: this.mention_stats_task_sort_next(),
				settings: {},
				status: 'draft',
			} )
			this.selected_mention_stats_task_id( record.id )
			return next
		}

		selected_mention_stats_task_id( next?: string ) {
			const current = this.selected_mention_stats_task_id_for( this.active_user_id(), next )
			if( next !== undefined ) return current
			return this.mention_stats_task( current ) ? current : ''
		}

		@ $mol_mem_key
		selected_mention_stats_task_id_for( user: string, next?: string ) {
			$mol_wire_solid()
			return next ?? ''
		}

		@ $mol_action
		mention_stats_task_open( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.selected_mention_stats_task_id( id )
			return next
		}

		mention_stats_task_title( id: string ) {
			return String( this.mention_stats_task( id )?.title || id )
		}

		@ $mol_mem_key
		mention_stats_task_title_draft( id: string, next?: string ) {
			$mol_wire_solid()
			return next ?? this.mention_stats_task_title( id )
		}

		@ $mol_action
		mention_stats_task_title_commit( id: string, next?: Event ) {
			if( next === undefined ) return null
			const previous = this.mention_stats_task_title( id )
			const title = this.mention_stats_task_title_draft( id ).trim()
			if( !title ) this.mention_stats_task_title_draft( id, previous )
			else {
				if( title !== previous && this.admin_authenticated() ) this.$.$shm_pb.update_record( 'mention_stats_tasks', id, { title } )
				this.mention_stats_task_title_draft( id, title )
			}
			return next
		}

		@ $mol_action
		mention_stats_task_title_keydown( id: string, next?: KeyboardEvent ) {
			if( next?.key !== 'Escape' ) return next ?? null
			next.preventDefault()
			this.mention_stats_task_title_draft( id, this.mention_stats_task_title( id ) )
			this.Mention_stats_task_title( id ).focused( false )
			return next
		}

		@ $mol_action
		mention_stats_task_delete( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.mention_stats_task_delete_showed( id, false )
			if( this.admin_authenticated() ) this.$.$shm_pb.delete_record( 'mention_stats_tasks', id )
			if( this.selected_mention_stats_task_id() === id ) this.selected_mention_stats_task_id( '' )
			return next
		}

		mention_stats_task_delete_cancel( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.mention_stats_task_delete_showed( id, false )
			return next
		}

		wordstat_task( id: string ) {
			return this.wordstat_tasks().find( task => task.id === id ) ?? null
		}

		wordstat_task_rows() {
			const tasks = this.wordstat_tasks()
			return tasks.length ? tasks.map( task => this.Wordstat_task( task.id ) ) : [ this.Wordstat_empty() ]
		}

		wordstat_content_rows() {
			return [
				this.Wordstat_user_settings(),
				this.Wordstat_toolbar(),
				this.Wordstat_list(),
				... this.selected_wordstat_task_id() ? [ this.Wordstat_dashboard() ] : [],
			]
		}

		wordstat_task_title_next() {
			const used = new Set( this.wordstat_tasks().map( task => String( task.title || '' ).trim() ) )
			for( let index = 1; ; ++ index ) if( !used.has( `Задача ${ index }` ) ) return `Задача ${ index }`
		}

		wordstat_task_sort_next() {
			return this.wordstat_tasks().reduce( ( max, task )=> Math.max( max, Number( task.sort || 0 ) ), 0 ) + 10
		}

		wordstat_default_settings() {
			return {
				queries: '',
				regions: 'Все',
				period_kind: 'PERIOD_MONTHLY',
				period_kinds: { PERIOD_DAILY: false, PERIOD_WEEKLY: false, PERIOD_MONTHLY: true },
				devices: { DEVICE_ALL: true, DEVICE_DESKTOP: false, DEVICE_PHONE: false, DEVICE_TABLET: false },
			}
		}

		@ $mol_action
		wordstat_create( next?: Event ) {
			if( next === undefined ) return null
			const user = this.active_user_id()
			if( !user || !this.admin_authenticated() ) return next
			const record = this.$.$shm_pb.create_record( 'wordstat_tasks', {
				user,
				title: this.wordstat_task_title_next(),
				sort: this.wordstat_task_sort_next(),
				mode: 'edit',
				settings: this.wordstat_default_settings(),
			} )
			this.selected_wordstat_task_id( record.id )
			return next
		}

		selected_wordstat_task_id( next?: string ) {
			const current = this.selected_wordstat_task_id_for( this.active_user_id(), next )
			if( next !== undefined ) return current
			return this.wordstat_task( current ) ? current : ''
		}

		@ $mol_mem_key
		selected_wordstat_task_id_for( user: string, next?: string ) {
			$mol_wire_solid()
			return next ?? ''
		}

		@ $mol_action
		wordstat_task_open( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.selected_wordstat_task_id( id )
			return next
		}

		wordstat_task_title( id: string ) {
			return String( this.wordstat_task( id )?.title || id )
		}

		wordstat_task_queries( id: string ) {
			const settings = this.wordstat_task( id )?.settings as { queries?: string } | undefined
			return [ ... new Set( String( settings?.queries || '' ).split( /\r?\n/ ).map( value => value.trim() ).filter( Boolean ) ) ].join( ', ' ) || '—'
		}

		wordstat_task_subtasks( id: string ) {
			return Number( this.wordstat_task( id )?.collect_total || 0 ).toLocaleString( 'ru-RU' )
		}

		wordstat_task_period( id: string ) {
			const dates = this.wordstat_task_items()
				.filter( item => String( item.task || '' ) === id )
				.map( item => String( item.date_from || '' ).slice( 0, 10 ) )
				.filter( Boolean )
				.sort()
			if( !dates.length ) return '—'
			const [ year, month, day ] = dates[0].split( '-' )
			return year && month && day ? `${ day }.${ month }.${ year }` : dates[0]
		}

		wordstat_task_daily( id: string, next?: boolean ) {
			const task = this.wordstat_task( id )
			if( next === undefined ) return Boolean( task?.regular_daily )
			if( task?.id && this.admin_authenticated() ) this.$.$shm_pb.update_record( 'wordstat_tasks', id, { regular_daily: next } )
			return next
		}

		@ $mol_mem_key
		wordstat_task_title_draft( id: string, next?: string ) {
			$mol_wire_solid()
			return next ?? this.wordstat_task_title( id )
		}

		@ $mol_action
		wordstat_task_title_commit( id: string, next?: Event ) {
			if( next === undefined ) return null
			const previous = this.wordstat_task_title( id )
			const title = this.wordstat_task_title_draft( id ).trim()
			if( !title ) this.wordstat_task_title_draft( id, previous )
			else {
				if( title !== previous && this.admin_authenticated() ) this.$.$shm_pb.update_record( 'wordstat_tasks', id, { title } )
				this.wordstat_task_title_draft( id, title )
			}
			return next
		}

		@ $mol_action
		wordstat_task_title_keydown( id: string, next?: KeyboardEvent ) {
			if( next?.key !== 'Escape' ) return next ?? null
			next.preventDefault()
			this.wordstat_task_title_draft( id, this.wordstat_task_title( id ) )
			this.Wordstat_task_title( id ).focused( false )
			return next
		}

		@ $mol_action
		wordstat_task_delete( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.wordstat_task_delete_showed( id, false )
			if( this.admin_authenticated() ) this.$.$shm_pb.delete_record( 'wordstat_tasks', id )
			if( this.selected_wordstat_task_id() === id ) this.selected_wordstat_task_id( '' )
			return next
		}

		wordstat_task_delete_cancel( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.wordstat_task_delete_showed( id, false )
			return next
		}

		async csv_to_duckdb_upload( id: string, file: File, visible_tags: readonly string[] ) {
			const query = new URLSearchParams({
				dashboard: id,
				filename: file.name,
				title: file.name.replace( /\.[^.\/\\]+$/, '.duckdb' ),
				pb_url: this.$.$shm_pb.url(),
				visible_tags: JSON.stringify( visible_tags ),
			})
			const response = await fetch( `${ this.csv_to_duckdb_url() }?${ query }`, {
				method: 'POST',
				headers: {
					Authorization: this.$.$shm_pb.auth_header_token( this.$.$shm_pb.auth_token() ),
					'Content-Type': 'application/octet-stream',
				},
				body: file,
			} )
			const text = await response.text()
			const data = text ? JSON.parse( text ) : null

			if( !response.ok ) {
				const message = data?.message || response.statusText || 'CSV to DuckDB failed'
				throw new Error( String( message ) )
			}

			this.$.$shm_pb.realtime_version( 'dashboard_files/*', Date.now() )
			return data
		}

	}

}
